export default class PartnerObject {
  static _objectDefinition() {
    return {
      PartnerId: 0,
      Name: "",
      Address: "",
      City: "",
      PostalCode: "",
      Email: "",
      AdministrationEmail: "",
      NoReplyEmailAddress: "",

      IBAN: "",
      Type: "",
      SupplierCode: "",
     // COC: "",
      VatNumber: "",
      DirectDebitAuthorisationDate: "",
      AccountHolderName: "",
      DirectDebitMandateId: "",
      ServicePrice: 0,
      MinimumServicePrice: 0,
      CampaignBudget: 0,
      NotifyBooked: false,
      NotifyArrived: false,
      PlanningContract: false,
      PaymentContract: false,
      PaymentPlatform: "",
      TermsAccepted: false,
      Active: false,
      DirectDebit: false,
      MinMonthlyFee: 0,
     PartnerLevel: 1,
      ExternalEventBridges: {
        Formitable: {
          ApiKey: ""
        },
        TicketCounter: {
          ClientId: "",
          ClientSecret: "",
          Username: "",
          Password: "",
          RefreshToken: ""
        }
      }
    };
  }
}
